import getData from '../getData';
import { createSelector } from '@reduxjs/toolkit';

/**
 * Получение автомобиля из redux
 */
const getCar = createSelector(getData, ({ car }) => car);

export default getCar;
